import React from "react";
import { ReactComponent as PlantSvg } from "../svg/plant.svg";

export default function PlantIcon({ size = 64, color = "#32363F", ...props }) {
  return <PlantSvg width={size} height={size} style={{ color }} {...props} />;
}
